// extracted by mini-css-extract-plugin
export default {"addressAction":"O4-z","loading":"P4-z"};